<template>
  <v-tooltip v-if="ready" :text="_tooltip" location="top">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        :density="_density"
        :color="_color"
        :type="_type"
        :disabled="_disabled"
        @click="handleClick"
        :class="_buttonClass"
        :variant="_variant"
        :size="_size"
        :width="_width"
      >
        <v-icon v-if="icon != null" :icon="icon" :class="_iconClass" :size="_size" />
        <span v-else>{{ label }}</span>
      </v-btn>
    </template>
  </v-tooltip>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Density } from 'vuetify/lib/composables/density'

type Variant = "text" | "flat" | "elevated" | "tonal" | "outlined" | "plain" | undefined

@Options({
  props: {
    color: String,
    disabled: Boolean,
    buttonClass: String,
    iconClass: String,
    click: Function,
    type: String,
    label: String,
    icon: String,
    size: String,
    tooltip: String,
    variant: String,
    density: String,
    value: typeof Number || typeof String || typeof Boolean || typeof Array || typeof Object,
    width: String,
  }
})
export default class Button extends Vue {
  color?: string
  disabled?: boolean
  buttonClass?: string
  iconClass?: string
  click!: Function
  type?: string
  label?: string
  icon?: string
  size?: string
  tooltip?: string
  ready: boolean = false
  value?: number
  variant?: string
  density?: string
  width?: string

  mounted() {
    this.ready = true
  }

  get _density(): Density {
    return this.density != null ? this.density as Density : 'compact'
  }
  get _variant(): Variant {
    return this.variant != null ? this.variant as Variant : 'plain'
  }
  get _color(): string {
    return this.color != null ? this.color : ''
  }
  get _disabled(): boolean {
    return this.disabled != null ? this.disabled : false
  }
  get _buttonClass(): string {
    return this.buttonClass != null ? `${this.buttonClass} btn-defaults` : 'btn-defaults'
  }
  get _iconClass(): string {
    return this.iconClass != null ? this.iconClass : ''
  }
  get _type(): string {
    return this.type != null ? this.type : ''
  }
  get _label(): string {
    return this.label != null ? this.label : ''
  }
  get _size(): string {
    return this.size != null ? this.size : ''
  }
  get _width(): string {
    return this.width != null ? this.width : ''
  }

  get _tooltip(): string {
    if (this.tooltip != null) {
      return this.tooltip
    }
    if (this.label != null) {
      return this.label
    }
    if (this.icon != null) {
      return this.icon.replace('mdi-', '').replace('-', ' ')
    }
    return ''
  }
  get _click(): Function {
    if (this.click != null) {
      return this.click
    }
    return () => {}
  }

  handleClick(event: Event): void {
    if (this.click) {
      this.click(event, this.value);
    }
    this.$emit('click', event, this.value);
  }
}
</script>
<style scoped lang="scss">
.btn-defaults {
  min-width: 24px;
}
</style>
